export default __webpack_public_path__ + "static/media/Schedule.70d7476b.svg";